import React, { useState } from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch } from "react-redux";
import { formatTimestamp } from "../../../../../../utils/formatter/dateTimeFormatter";
import { formatPath } from "../../../../../../utils/fileSystemHelper";
import { ConfirmDialog } from "../../../../../../components";
import { actions as DownloadsActions } from "../../../../Ducks/Downloads.duck";
import { ButtonStyled } from "./DownloadsTable.styles";
let filePath = null;
const DownloadsTable = (props) => {
  const { className, files, rowsPerPage, loading, downloadFile } = props;
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const dispatch = useDispatch();
  const handleDelete = async () => {
    if (filePath !== null) {
      dispatch(DownloadsActions.deleteFile(filePath));
    }
  };
  return /* @__PURE__ */ React.createElement(Card, { className }, /* @__PURE__ */ React.createElement(CardContent, { sx: { padding: 0 } }, /* @__PURE__ */ React.createElement(PerfectScrollbar, null, /* @__PURE__ */ React.createElement(Box, { sx: { minWidth: 1050 } }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "files.name" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "files.createdAt" })), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "files.actions" })))), /* @__PURE__ */ React.createElement(TableBody, null, loading && new Array(rowsPerPage).fill((index) => index).map((value, index) => /* @__PURE__ */ React.createElement(TableRow, { key: index }, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)), /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Skeleton, null)))), !loading && files.map((file) => /* @__PURE__ */ React.createElement(TableRow, { hover: true, key: file.path }, /* @__PURE__ */ React.createElement(TableCell, null, /* @__PURE__ */ React.createElement(Box, { sx: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, formatPath(file.path)))), /* @__PURE__ */ React.createElement(TableCell, null, formatTimestamp(file.last_modified)), /* @__PURE__ */ React.createElement(TableCell, null, file.type !== "dir" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ButtonStyled, { onClick: () => downloadFile(file.path) }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "files.download" })), /* @__PURE__ */ React.createElement(
    ButtonStyled,
    {
      onClick: () => {
        filePath = file.path;
        setConfirmDeleteOpen(true);
      }
    },
    /* @__PURE__ */ React.createElement(FormattedMessage, { id: "files.delete" })
  )))))))))), /* @__PURE__ */ React.createElement(CardActions, { sx: { justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(TableFooter, null, /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, null, `Results: ${files.length}`)))), /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: "Delete file?",
      open: confirmDeleteOpen,
      setOpen: setConfirmDeleteOpen,
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "files.confirmDelete" }))
  ));
};
DownloadsTable.propTypes = {
  className: PropTypes.string,
  files: PropTypes.array.isRequired,
  deleteFile: PropTypes.func.isRequired,
  downloadFile: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired
};
export default DownloadsTable;
